import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  blogs: [],
  singleBlog: {},
};

const slice = createSlice({
  name: "blog",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // TODO: successFetch blog

    getBlogSuccess(state, action) {
      state.isLoading = false;
      state.blogs = action.payload;
    },

    // TODO: single blog fetch success

    getSingleBlogSucess(state, action) {
      state.isLoading = false;
      state.singleBlog = action.payload;
    },

    // Update blog
    updateBlogSuccess(state, action) {
      state.isLoading = false;
    },

    // delete blog
    deleteBlogSuccess(state, action) {
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

export function getBlogs(type, limit = 2000, page = 1) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`blogs`);
      dispatch(slice.actions.getBlogSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getBlog(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`blogs/${id}`);
      dispatch(slice.actions.getSingleBlogSucess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteBlog(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.delete(`blog/${id}`);
      dispatch(slice.actions.deleteBlogSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
